export default {"src":"/_next/static/media/mercycorp.517b9409.svg","height":49,"width":140,"blurWidth":0,"blurHeight":0};